/** 商品名にバリエーション名を「商品名(バリエーション名)」の形で添える。バリエーションが無ければ商品名のみ */
export const formatProductVariationName = (
  productName: string,
  variationName: string | undefined
): string => {
  if (variationName !== undefined && variationName !== "") {
    return `${productName}(${variationName})`;
  }
  return productName;
};
